import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import MarksEntryCourse from "../components/MarksEntryFormCourse";
import marksentryapi from '../api/marksheetUploadRouter';
import loginapi from '../api/login';


import { APISERVERURL } from '../APIServerURL';


const MarksEntryForm = ({accessToken,setAccessToken,setRefreshFailed}) => {
  const navigate = useNavigate();
  const { courseCode,session,batch } = useParams();
  const [studentListLoaded,setStudentListLoaded]=useState(false);
  const [courseDetailsLoaded,setCourseDetailsLoaded]=useState(false);
  
  const [marksData, setMarksData] = useState([
    //{ slno: 1, rollno: "CSB21001", name: "Mr Bonsai Hazarika Das", Mid: 12, Prc: 20, End: 70 },
   // { slno: 2, rollno: "CSB21009", name: "Mr yyy", Mid: 10, Prc: 19, End: 72 },
  ]);
  const [courseDetails,setCourseDetails]=useState(null);
  const [submissionStatus,setSubmissionStatus]=useState('done');

  const [midTermTotal,setMidTermTotal]=useState(0);
  const [endTermTotal,setEndTermTotal]=useState(0);
  const [practicalTotal,setPracticalTotal]=useState(0);

  const [credit,setCredit]=useState(0);

  const [courseTitle,setCourseTitle]=useState('');

   const handleClick = async () => {
    const isConfirmed = window.confirm("After submit you wont be able to edit the marks. Are you sure you want to submit?");
    if (isConfirmed) {
      // Proceed with the actual work
      setStudentListLoaded(false);
      setCourseDetailsLoaded(false);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/submitMarks',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        await fetchAllFormFillupStudents();
        await fetchBatchSubmissionDetails();
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/submitMarks',{batch,session,courseCode},{headers:{'Authorization':`Bearer ${nat}`}});   
                        await fetchAllFormFillupStudents();
                        await fetchBatchSubmissionDetails();
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
      
    } else {
      
    }
  };
 

    const handleComputeScore = async () => {
    const isConfirmed = window.confirm("This action will overwrite GTTL and %. Are you sure you want to continue?");
    if (isConfirmed) {
      // Proceed with the actual work
      setStudentListLoaded(false);
      const midTotal=midTermTotal;//(courseDetails?courseDetails.midTermTotal?courseDetails.midTermTotal:0:0||0);
      const practicalTotalx=practicalTotal;//(courseDetails?courseDetails.practicalTotal?courseDetails.practicalTotal:0:0);
      const theoryTotal=endTermTotal;//(courseDetails?courseDetails.endTermTotal?courseDetails.endTermTotal:0:0);
      //alert(midTotal+" "+practicalTotalx+" "+theoryTotal);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await marksentryapi.post('/updateFinalScoreOfABatch',{batch,session,courseCode,midTotal,practicalTotal:practicalTotalx,theoryTotal},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        //alert("ok");
        await fetchAllFormFillupStudents();
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await marksentryapi.post('/updateFinalScoreOfABatch',{batch,session,courseCode,midTotal,practicalTotal:practicalTotalx,theoryTotal},{headers:{'Authorization':`Bearer ${nat}`}});   
                        await fetchAllFormFillupStudents();
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              //setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
      
    } else {
    }
  };
const handleGoBack = () => {
    navigate(`/marksentrybatches/${courseCode}/${session}`); 
  };



const fetchAllFormFillupStudents=async ()=>{
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await marksentryapi.post('/getAllFormFillupStudentsOfABatch',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setMarksData(response.data.marksData);setStudentListLoaded(true);
      //alert(JSON.stringify(response.data.marksData));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await marksentryapi.post('/getAllFormFillupStudentsOfABatch',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setMarksData(response.data.marksData);setStudentListLoaded(true);
                      //alert(response.data);
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  }

  const fetchBatchSubmissionDetails=async ()=>{
    try{       
      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
      const response=await marksentryapi.post('/getBatchSubmissionDetails',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      setCourseDetails(response.data.courseDetails); 
      setSubmissionStatus(response.data.courseDetails.submissionStatus);
setMidTermTotal(response.data.courseDetails.midTermTotal);
      setEndTermTotal(response.data.courseDetails.endTermTotal);
      setPracticalTotal(response.data.courseDetails.practicalTotal);

      setCredit(response.data.courseDetails.credit);

      setCourseTitle(response.data.courseDetails.title);
      setCourseDetailsLoaded(true);
      //alert(JSON.stringify(response.data.courseDetails));
      }
      catch(err)
      {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);            
          const nat=x['data']['accessToken'];
          const lt=x['data']['loginType'];
          //alert(nat);
          setAccessToken(nat);
          setRefreshFailed(false);  
                  
         
            if(lt.toLowerCase()==="admin")
              {
                    try{       
                      //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                      const response=await marksentryapi.post('/getBatchSubmissionDetails',{session:session,courseCode:courseCode,batch:batch},{headers:{'Authorization':`Bearer ${nat}`}});   
                      setCourseDetails(response.data.courseDetails);

                     setMidTermTotal(response.data.courseDetails.midTermTotal);
      setEndTermTotal(response.data.courseDetails.endTermTotal);
      setPracticalTotal(response.data.courseDetails.practicalTotal);

       setCredit(response.data.courseDetails.credit);

                      setSubmissionStatus(response.data.courseDetails.submissionStatus); 

                      setCourseDetailsLoaded(true);
                      //alert(response.data);
                  }
                  catch(err)
                  {
                    if( err.response.status===403)
                      {
                        navigate(`/accessdenied`); 
                      }
                    //alert('refresh failed unusual'+JSON.stringify(err));
                    setAccessToken('');
                    setRefreshFailed(true);  
                  }
                }
          }
          catch(err)
          {
            //alert('dd');
            setAccessToken(''); 
            setRefreshFailed(true);              
          }
      }         
       finally
          {
            //setIsAppLoaded(true);
            //alert('app loaded'+accessToken);
          }
  }


   const  updateMarksConfigurationOfABatch  = async (field, value) => {
    //alert("shfvdk");
    try {
        //update courseCode,session ,marksData[index][rollno],field,value
      const response=await marksentryapi.post('/updateMarksConfigurationOfABatch',{session:session,courseCode:courseCode,batch:batch,term:field,mark:value},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setMarksData(response.data.marksData);
      
    } catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);            
        const nat=x['data']['accessToken'];
        const lt=x['data']['loginType'];
        //alert(nat);
        setAccessToken(nat);
        setRefreshFailed(false);  
                
       
          if(lt.toLowerCase()==="admin")
            {
                  try{       
                    //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                    const response=await marksentryapi.post('/updateMarksConfigurationOfABatch',{session:session,courseCode:courseCode,batch:batch,term:field,mark:value},{headers:{'Authorization':`Bearer ${nat}`}});   
                    //setMarksData(response.data.marksData);
                    //alert(response.data);
                }
                catch(err)
                {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  //alert('refresh failed unusual'+JSON.stringify(err));
                  setAccessToken('');
                  setRefreshFailed(true);  
                }
              }
        }
        catch(err)
        {
          //alert('dd');
          setAccessToken(''); 
          setRefreshFailed(true);              
        }
    }         
     finally
        {
          //setIsAppLoaded(true);
          //alert('app loaded'+accessToken);
        }
  };

    const deleteStudentFromCourse = async (rollno) => {
    setStudentListLoaded(false);
    try {
        //update courseCode,session ,marksData[index][rollno],field,value
      const response=await marksentryapi.post('/deleteStudentFromCourse',{session:session,courseCode:courseCode,rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setMarksData(response.data.marksData);
      //alert('deleted');
      await fetchAllFormFillupStudents();
    } catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);            
        const nat=x['data']['accessToken'];
        const lt=x['data']['loginType'];
        //alert(nat);
        setAccessToken(nat);
        setRefreshFailed(false);  
                
       
          if(lt.toLowerCase()==="admin")
            {
                  try{       
                    //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                    const response=await marksentryapi.post('/deleteStudentFromCourse',{session:session,courseCode:courseCode,rollno},{headers:{'Authorization':`Bearer ${nat}`}});   
                    //alert('deleted');
                    await fetchAllFormFillupStudents();
                    //setMarksData(response.data.marksData);
                    //alert(response.data);
                }
                catch(err)
                {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  //alert('refresh failed unusual'+JSON.stringify(err));
                  setAccessToken('');
                  setRefreshFailed(true);  
                }
              }
        }
        catch(err)
        {
          //alert('dd');
          setAccessToken(''); 
          setRefreshFailed(true);              
        }
    }         
     finally
        {
          //setIsAppLoaded(true);
          //alert('app loaded'+accessToken);
          setStudentListLoaded(true);
        }
  };
  
useEffect(()=>{
   
  fetchAllFormFillupStudents();
  },[]);
  
useEffect(()=>{
   
  fetchBatchSubmissionDetails();
  },[]);
 
  
 const updateMarks = (index, field, value) => {
    const updatedMarks = [...marksData];
    updatedMarks[index][field] = value;
    setMarksData(updatedMarks);
  };

  const updateMarksBackEnd = async (index, field, value) => {
    try {
        //update courseCode,session ,marksData[index][rollno],field,value
      const response=await marksentryapi.post('/updateMarkOfATerm',{session:session,courseCode:courseCode,rollno:marksData[index]['rollno'],term:field,mark:value},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setMarksData(response.data.marksData);
      //alert('k');
    } catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);            
        const nat=x['data']['accessToken'];
        const lt=x['data']['loginType'];
        //alert(nat);
        setAccessToken(nat);
        setRefreshFailed(false);  
                
       
          if(lt.toLowerCase()==="admin")
            {
                  try{       
                    //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                    const response=await marksentryapi.post('/updateMarkOfATerm',{session:session,courseCode:courseCode,rollno:marksData[index]['rollno'],term:field,mark:value},{headers:{'Authorization':`Bearer ${nat}`}});   
                    //setMarksData(response.data.marksData);
                    //alert(response.data);
                }
                catch(err)
                {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  //alert('refresh failed unusual'+JSON.stringify(err));
                  setAccessToken('');
                  setRefreshFailed(true);  
                }
              }
        }
        catch(err)
        {
          //alert('dd');
          setAccessToken(''); 
          setRefreshFailed(true);              
        }
    }         
     finally
        {
          //setIsAppLoaded(true);
          //alert('app loaded'+accessToken);
        }
  };


  function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }

async function handleDownloadCSV(e)
    {
      e.preventDefault();
      try{
        const response= await marksentryapi.post('/getMarksEntryCSV',{session:session,courseCode:courseCode,batch},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await marksentryapi.post('/getMarksEntryCSV',{session:session,courseCode:courseCode,batch},{headers:{'Authorization':`Bearer ${nat}`}});    
            downloadFile(response.data);
           }
           catch(err)
           {
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
    }
  const  updateBatchCourseDetailsTitle  = async (value) => {
    //alert("shfvdk");
    try {
        //update courseCode,session ,marksData[index][rollno],field,value
      const response=await marksentryapi.post('/updateBatchCourseDetailsTitle',{session:session,courseCode:courseCode,batch:batch,title:value},{headers:{'Authorization':`Bearer ${accessToken}`}});  
      //setMarksData(response.data.marksData);
      
    } catch(err)
    {
      if( err.response.status===403)
        {
          navigate(`/accessdenied`); 
        }
      try{
        const config = { withCredentials: true };
        const x=await loginapi.get('/getAccessToken',config);            
        const nat=x['data']['accessToken'];
        const lt=x['data']['loginType'];
        //alert(nat);
        setAccessToken(nat);
        setRefreshFailed(false);  
                
       
          if(lt.toLowerCase()==="admin")
            {
                  try{       
                    //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                    const response=await marksentryapi.post('/updateBatchCourseDetailsTitle',{session:session,courseCode:courseCode,batch:batch,title:value},{headers:{'Authorization':`Bearer ${nat}`}});   
                    //setMarksData(response.data.marksData);
                    //alert(response.data);
                }
                catch(err)
                {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  //alert('refresh failed unusual'+JSON.stringify(err));
                  setAccessToken('');
                  setRefreshFailed(true);  
                }
              }
        }
        catch(err)
        {
          //alert('dd');
          setAccessToken(''); 
          setRefreshFailed(true);              
        }
    }         
     finally
        {
          //setIsAppLoaded(true);
          //alert('app loaded'+accessToken);
        }
  };

  return (
    <main className="flex flex-col items-center">
    <div className="text-center p-4">
      <h1 className="text-2xl text-gray-600">MARKS ENTRY FORM</h1>
      <p className="font-semibold text-xs">(The form is autosave)</p>
      {/* Add marks entry form here */}
    </div>
    {studentListLoaded && courseDetailsLoaded && <div className="w-[98%] max-w-[1200px]">

      <div className="flex flex-col flex-1 m-2">
                            <p className="text-gray-500  font-small text-xs">TITLE</p> 
                            <input
                                className="w-full bg-transparent text-gray-900 font-medium text-sm font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={courseTitle||''}
                                onChange={(e) => setCourseTitle(e.target.value)}
                                onBlur={(e) => updateBatchCourseDetailsTitle(e.target.value)}
                              
                                />
                        </div>


        <div className="w-full font-semibold border-b text-center">
        
            <button 
              className="underline text-blue-600 hover:text-blue-800 cursor-pointer text-xs"
              onClick={handleDownloadCSV}
            >
              DOWNLOAD CSV
            </button>
        </div>
        <div className="w-full border-b  grid grid-cols-[1fr_1fr_3fr] gap-1 p-1 text-center">
            <div className="bg-white p-1">
                <div >
                    <p className="text-gray-700  font-small text-xs">CODE</p>
                    <p className="text-gray-900 font-medium text-md">  {courseDetails?courseDetails.code:''}</p>
                </div>
            </div>
            <div className="bg-white p-1">
                <div>
                    <p className="text-gray-700  font-small text-xs">Cr.</p>
                   <input
                                type="number"
                                className="text-gray-900 font-medium text-md font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={credit||0}
                                onChange={(e) => setCredit(e.target.value)}
                                onBlur={(e) => updateMarksConfigurationOfABatch( "credit",Number(e.target.value))}
                                disabled={submissionStatus!=='marksentry'}
                                />
                </div>
            </div>
            <div className="bg-white p-1 grid grid-cols-3 gap-2">
            <div className="text-center">
              <p className="text-gray-700  font-small text-xs">MID Total</p> 
              
              <input
                                type="number"
                                className="text-gray-900 font-medium text-md font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                value={midTermTotal||0}
                                onChange={(e) => setMidTermTotal(e.target.value)}
                                onBlur={(e) => updateMarksConfigurationOfABatch( "midterm_total",Number(e.target.value))}
                                disabled={submissionStatus!=='marksentry'}
                                />
            </div>
                <div className="text-center">
                    <p className="text-gray-700  font-small text-xs">End Prctl Total</p> 
                   <input
                                type="number"
                                className="text-gray-900 font-medium text-md font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                                 value={practicalTotal||0}
                                onChange={(e) => setPracticalTotal(e.target.value)}
                                onBlur={(e) => updateMarksConfigurationOfABatch( "practical_total",Number(e.target.value))}
                                disabled={submissionStatus!=='marksentry'}
                                />
                </div> 
                <div className="text-center">
                    <p className="text-gray-700  font-small text-xs">End Theory Total</p> 
                    <input
                                type="number"
                                className="text-gray-900 font-medium text-md font-semibold border-b-2 border-blue-500 focus:border-green-500 outline-none p-1 text-center"
                               value={endTermTotal||0}
                                onChange={(e) => setEndTermTotal(e.target.value)}
                                onBlur={(e) => updateMarksConfigurationOfABatch( "endterm_total",Number(e.target.value))}
                                disabled={submissionStatus!=='marksentry'}
                                />
                </div> 
            </div>
        </div>

        <div className="w-full border bg-gray-100 grid grid-cols-[1fr_1fr_2fr_4fr_1fr_1fr_1fr_1fr_1fr_1fr] gap-1 p-1 mt-2 text-xs">
               <div  className="w-full text-center">
               
               </div> 
               <div  className="w-full text-center">
                SN
               </div>
               <div  className="w-full text-center">
                RLNO
               </div>
               <div  className="w-full text-center">
                NAME
               </div>
               <div  className="w-full text-center">
                MID
               </div>
               <div  className="w-full text-center">
                End-Practcl(EPR)
               </div>
               <div  className="w-full text-center">
                End-Theory(ETH)
               </div>
               <div  className="w-full text-center">
                 {courseDetails?.midTermTotal > 0 ? 'M /30' : 'M /0'}
               </div>
               <div  className="w-full text-center">
                 {courseDetails?.midTermTotal > 0 ? '(ET+EP) /70' : '(ET+EP) /100'}
               </div>
               <div  className="w-full text-center">
                GTL /100
               </div>
        </div>
        {marksData.map((student, index) => (
          <MarksEntryCourse
            key={student.rollno}
            student={student}
            index={index}
            updateMarks={updateMarks}
            updateMarksBackEnd={updateMarksBackEnd}
            state={submissionStatus}// {courseDetails?courseDetails.submissionStatus?courseDetails.submissionStatus:'done':'done'}
            mt={(courseDetails?courseDetails.midTermTotal?courseDetails.midTermTotal:0:0||0)}
            pt={(courseDetails?courseDetails.practicalTotal?courseDetails.practicalTotal:0:0)}
            et={(courseDetails?courseDetails.endTermTotal?courseDetails.endTermTotal:0:0)}
            
            deleteStudentFromCourse={deleteStudentFromCourse}
          />
        ))}

<div className="w-full flex justify-between p-2 mt-2 mb-2 flex flex-wrap">
      {/* GO BACK button */}
      <button 
        onClick={handleGoBack} 
        className="ml-2 mt-2 bg-green-500 text-white py-2 px-4 rounded hover:bg-gray-700 text-xs"
      >
        GO BACK
      </button>

      {submissionStatus === "marksentry" ? (
        <>
        <button 
          onClick={handleComputeScore} 
          className="ml-2 mt-2 bg-yellow-500 text-white py-2 px-4 rounded hover:bg-gray-700 text-xs"
        >
          COMPUTE SCORE
        </button>

        <button 
          onClick={handleClick} 
          className="ml-2 mt-2 bg-blue-500 text-white py-2 px-4 rounded hover:bg-gray-700 text-xs"
        >
          SUBMIT
        </button>
        </>
      ) : (
        <button 
          disabled 
          className="ml-2 mt-2 bg-gray-300 text-gray-600 py-2 px-4 rounded text-xs cursor-not-allowed"
        >
          ALREADY SUBMITTED
        </button>
      )}      
    </div>

    </div>
   }
   {
   (!studentListLoaded || !courseDetailsLoaded) && <div className="w-[98%] max-w-[1200px]">
    Please wait!
    </div>
    }
    </main>
  );
};

export default MarksEntryForm;
